import { Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";

export default function ForbiddenPage() {
  return (
    <div className="bg-[#070d18] text-slate-100 min-h-[70vh] flex items-center justify-center py-20 px-4">
      <SEOHead
        title="Adgang ikke tilladt"
        description="Du har ikke adgang til denne side på KVC Express ApS."
      />

      <div className="max-w-lg w-full text-center space-y-6 bg-[#0b1426] p-8 sm:p-12 rounded-2xl border border-slate-800 shadow-2xl">
        <div className="w-16 h-16 rounded-full bg-red-950/80 border border-red-800 text-red-400 flex items-center justify-center mx-auto text-2xl font-mono font-bold">
          403
        </div>

        <h1 className="text-2xl sm:text-3xl font-bold text-white font-display">
          Adgang ikke tilladt
        </h1>

        <p className="text-slate-300 text-sm leading-relaxed">
          Du har ikke adgang til denne side.
        </p>

        <div className="pt-4 flex items-center justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-lg bg-[#0F766E] hover:bg-[#115E59] text-white font-semibold text-xs uppercase tracking-wider transition shadow-lg shadow-[#0F766E]/30"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Til forsiden</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
